import { render, staticRenderFns } from "./ConfigurationLayout.vue?vue&type=template&id=8fbbc67e&scoped=true"
import script from "./ConfigurationLayout.vue?vue&type=script&lang=js"
export * from "./ConfigurationLayout.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationLayout.vue?vue&type=style&index=0&id=8fbbc67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbbc67e",
  null
  
)

export default component.exports